var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5766 0.25C15.3383 0.25 15.9828 0.894531 15.9828 1.65625V10.0938C15.9828 10.8848 15.3383 11.5 14.5766 11.5H2.38906C1.59805 11.5 0.982812 10.8848 0.982812 10.0938V1.65625C0.982812 0.894531 1.59805 0.25 2.38906 0.25H14.5766ZM14.5766 1.65625H2.38906V2.85742C3.03359 3.41406 4.08828 4.23438 6.31484 5.99219C6.81289 6.37305 7.77969 7.31055 8.48281 7.28125C9.15664 7.31055 10.1234 6.37305 10.6215 5.99219C12.848 4.23438 13.9027 3.41406 14.5766 2.85742V1.65625ZM2.38906 10.0938H14.5766V4.67383C13.9027 5.20117 12.9359 5.96289 11.5004 7.10547C10.8266 7.60352 9.71328 8.7168 8.48281 8.6875C7.22305 8.7168 6.08047 7.60352 5.43594 7.10547C4.00039 5.96289 3.03359 5.20117 2.38906 4.67383V10.0938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.3e8984280a5e235412c3f172524a4e3b.svg";
export { ForwardRef as ReactComponent };